var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"individual-match-ranking"},[_c('div',{staticClass:"sub-page-padding"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("個人戦ランキング")]),_c('p',[_vm._v("match.id: "+_vm._s(_vm.matchId))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }